import { Message } from './message';

export class MessageProxyV0 {
  public show: Message['show'];
  public close: Message['close'];
  public el: HTMLElement | null;

  constructor(message: Message, dom: MessageDOM) {
    // ここでもらう引数を MessageProxy オブジェクトのプロパティとして持たせてしまうと
    // view_javascript 内のスクリプトから Message や MessageManager などにアクセスできてしまうので
    // それをさせないようにコンストラクタの中で必要な関数のみを定義する形をとる
    this.show = message.show.bind(message);
    this.close = message.clickClose.bind(message);
    this.el = dom.el;
  }
}
